export default __webpack_public_path__ + "static/media/mavericks-icon.dfde45a0.jpeg";